import { useStore } from "vuex";
import { computed } from "vue";
import { NAMESPACE, ACTIVITY_TYPE } from "@modules/attempt/service/attempt.constant.ts";
import { isEmpty } from "@utils/var.check.ts";
import { useI18n } from "vue-i18n";

export function useLessonActivityConversation() {
  const store = useStore();
  const { t } = useI18n();

  const getAskSalisPermission = store.getters[`${NAMESPACE.ATTEMPT}/getAskSalisPermission`];
  const currentPageId = computed(() => store.getters[`${NAMESPACE.ATTEMPT}/currentPageId`]);
  const getActivity = computed(() => store.getters[`${NAMESPACE.RESOURCE}/getActivity`]);

  const isActivityValidToAskSalis = computed(() => {
    const permission = getAskSalisPermission(currentPageId.value);
    return !isEmpty(permission) && !!permission.isAttemptContextValidToAskSalis;
  });

  const hasPermissionToAskSalisInActivity = computed(() => {
    const permission = getAskSalisPermission(currentPageId.value);
    return !isEmpty(permission) && !!permission.canAskSalis;
  });

  const hasReachedAskSalisInteractionLimits = computed(() => {
    const permission = getAskSalisPermission(currentPageId.value);
    return !isEmpty(permission) && !!permission.hasReachedInteractionLimits;
  });

  const isConversationSuspended = computed(() => {
    const permission = getAskSalisPermission(currentPageId.value);
    return !isEmpty(permission) && !!permission.conversationSuspended;
  });

  const setConversationSuspended = (payload: {
    activityId: string | number;
    conversationSuspended: boolean;
  }): void => {
    store.dispatch(`${NAMESPACE.ATTEMPT}/setConversationSuspended`, payload);
  };

  const getAskSalisUnsupportedComponentTooltip = () => {
    const activity = getActivity.value(currentPageId.value);
    const isInQuizActivity = activity?.type === ACTIVITY_TYPE.ACTIVITY_QUIZ;

    if (isInQuizActivity) {
      return t("conversation_text_query_toolbar_salis_unavailable_quiz_tooltip_message");
    } else {
      return t("conversation_text_query_toolbar_salis_unavailable_activity_tooltip_message");
    }
  };

  return {
    isActivityValidToAskSalis,
    hasPermissionToAskSalisInActivity,
    hasReachedAskSalisInteractionLimits,
    isConversationSuspended,
    setConversationSuspended,
    getAskSalisUnsupportedComponentTooltip,
  };
}
